module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa27723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/font/glyphicons-halflings-regular.woff
// module id = kbUz
// module chunks = 0